<div>
  <div class="top-corner">
    <h3>
      Versions
    </h3>
    <button mat-button class="cta-button" (click)="addNewRow()"><mat-icon>add</mat-icon>Nouveau</button>

  </div>

  <div class="mat-elevation-z8" >

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>

      </ng-container>
      <!-- -->

      <!-- <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Code Marque</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span >{{element.code}}</span>
        <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.code"
          placeholder="Code" >
        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="makeName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Marque </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [hidden]="(editingItem && element.id===editingItemId)">{{element.makeName}}</span>
          <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
          placeholder="Constructeur" > -->

          @if ((editingItem && element.id===editingItemId)) {
            <mat-select matInput name="makeName"
              [(ngModel)]="editedItem.makeId" placeholder="Marque"
              (selectionChange)="onMakeChange()">
              @for (item of makes; track item) {
                <mat-option [value]="item.id" >{{item.name}}</mat-option>
              }
            </mat-select>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="modelName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Modèle </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [hidden]="(editingItem && element.id===editingItemId)">{{element.modelName}}</span>
          <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
          placeholder="Constructeur" > -->

          @if ((editingItem && element.id===editingItemId)) {
            <mat-select matInput name="modelName" [(ngModel)]="editedItem.modelId" placeholder="Modèle">
              @for (item of models; track item) {
                <mat-option [value]="item.id" >{{item.name}}</mat-option>
              }
            </mat-select>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Version </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [hidden]="(editingItem && element.id===editingItemId)">{{element.name}}</span>
          <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.name"
            placeholder="Nom" >
          </mat-cell>
        </ng-container>
        <!--
        <ng-container matColumnDef="engineName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Moteur </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">{{element.engineName}} <br /><i>({{element.engineFuelType}} - {{element.enginePower}} CV) </i></span>
            <mat-select matInput name="engineName" *ngIf="(editingItem && element.id===editingItemId)" [(ngModel)]="editedItem.engineId" placeholder="Moteur">
              <mat-option *ngFor="let item of engines" [value]="item.id" >{{item.name}}</mat-option>
            </mat-select>
          </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="engineNames">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Motorisations </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">@for (eng of element.engines; track eng; let i = $index) {
              <span>@if (i!=0) {
                <span>, </span>
              }{{eng.name}} </span>
            }</span>
            <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
            placeholder="Constructeur" > -->

            @if ((editingItem && element.id===editingItemId)) {
              <mat-select multiple matInput name="engineNames" [(ngModel)]="editedItem.engines" placeholder="Motorisations">
                @for (item of engines; track item) {
                  <mat-option [value]="item" >{{item.name}}</mat-option>
                }
              </mat-select>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="featureNames">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Features </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">@for (ft of element.features; track ft; let i = $index) {
              <span>@if (i!=0) {
                <span>, </span>
              }{{ft.code}} </span>
            }</span>
            <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.manufacturerId"
            placeholder="Constructeur" > -->

            @if ((editingItem && element.id===editingItemId)) {
              <mat-select multiple matInput name="featureNames" [(ngModel)]="editedItem.features" placeholder="Features">
                @for (item of features; track item) {
                  <mat-option [value]="item" >{{item.name}}</mat-option>
                }
              </mat-select>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastUpdated">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Modifié le </mat-header-cell>
          <mat-cell *matCellDef="let element" > {{dateTimeFormat(element.lastUpdated)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-button class="simple-button" (click)="editItem(element.id)" [hidden]="(editingItem && element.id===editingItemId)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-button class="simple-button" (click)="saveItem(element.id)" [hidden]="!(editingItem && element.id===editingItemId)" [disabled]="!editedItemIsValid()">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-button class="simple-button" (click)="deleteItem(element.id)">
              <mat-icon>{{editingItem && element.id===editingItemId ? 'undo' : 'delete'}}</mat-icon>{{editingItem && element.id===editingItemId ? '' : ''}}
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

  </div>
